import { FC } from 'react';

import { StaticNumericSpan } from '@myn/mui';

import { NumberFieldProps } from '../types.js';
import TextVariant from './TextVariant.jsx';

type Props = Pick<
  NumberFieldProps,
  'scale' | 'value' | 'decimalLimit' | 'placeholder' | 'prefix'
>;

const NumberVariant: FC<Props> = ({
  scale,
  value,
  decimalLimit,
  placeholder,
  prefix,
}) => {
  if (!value && value !== 0) {
    return <TextVariant scale={scale} value={null} placeholder={placeholder} />;
  }

  return (
    <StaticNumericSpan
      number={value}
      options={{
        minDecimals: decimalLimit,
        maxDecimals: decimalLimit,
        min: 0,
        prefix,
      }}
    />
  );
};

export default NumberVariant;
